import Badge from 'react-bootstrap/Badge'

import {
  capitalizeString,
  formatPhoneNumber,
  formatCurrency,
  formatDateTime,
  paymentStatuses,
  orderStatuses,
} from '../../../utilities/helpers'

function getHolderStatus(holder) {
  const isComp =
    holder?.complimentary === true ||
    holder?.complimentary === 't' ||
    holder?.complimentary === 1 ||
    holder?.status === 'comp'

  if (isComp) {
    return orderStatuses.comp || paymentStatuses.comp
  }

  if (!holder?.status) return null
  return paymentStatuses[holder.status] || orderStatuses[holder.status] || null
}

function formatPurchaseDate(holder) {
  const purchaseDate =
    holder?.processed_at || holder?.processedAt || holder?.purchase_date
  if (!purchaseDate) return ''
  return formatDateTime(purchaseDate, 'dateOnlyMdY') || ''
}

function formatDatePaid(holder) {
  const datePaid = holder?.date_paid || holder?.datePaid
  if (!datePaid) return ''
  return formatDateTime(datePaid, 'dateOnlyMdY') || ''
}

export default function Holder({ holder }) {
  const status = getHolderStatus(holder)

  return (
    <>
      <td>{holder?.seats || ''}</td>
      <td>{holder?.seat_count ?? holder?.number_of_seats ?? 0}</td>
      <td>{holder?.ticket_count ?? holder?.number_of_tickets ?? 0}</td>
      <td>{holder?.package_name || ''}</td>
      <td>{capitalizeString(`${holder?.first_name} ${holder?.last_name}`)}</td>
      <td>{holder?.email}</td>
      <td>{formatPhoneNumber(holder?.phone_number)}</td>
      <td>{holder?.address || ''}</td>
      <td>{formatPurchaseDate(holder)}</td>
      <td>{formatDatePaid(holder)}</td>
      <td>{formatCurrency(holder?.amount ?? 0)}</td>
      <td>{formatCurrency(holder?.total ?? 0)}</td>
      <td>
        {status ? (
          <Badge bg="none" className={`badge--${status.value}`}>
            {status.label}
          </Badge>
        ) : (
          holder?.status || ''
        )}
      </td>
    </>
  )
}
